import { render, staticRenderFns } from "./ViewDiscount.vue?vue&type=template&id=ec3445c6"
import script from "./ViewDiscount.vue?vue&type=script&lang=js"
export * from "./ViewDiscount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports